// @ts-check

import React, { Component, Fragment } from "react"
import { Input, TextArea } from "ui"
import DefineAction from "../../actions/DefineAction"
import { text, boolean } from "../../attributes/items/primitives"
import DefineProperty from "../../properties/DefineProperty"
import { evaluateFormulas } from "../../formulas/evaluate"
const html2canvas = require("html2canvas")

/**
 * @augments {Component<BlockTypeProps, {value: string}>}
 */
export default class HTML2CanvasBlockType extends Component {
    state = {
        value: "",
    }

    getValue = () => {
        console.log("Capturing")
        return import("html2canvas").then(html2canvas => {
            return html2canvas(document.getElementById(this.props.config.attributes.elementId), {
                dpi: 300,
            }).then(canvas => {
                const value = canvas.toDataURL()
                return this.setState({ value })
            })
        })
    }

    constructor(props) {
        super(props)
        const evaluate = evaluateFormulas(props.context)
        if (props.config.attributes.defaultValue) {
            this.state.value = evaluate(props.config.attributes.defaultValue)
        }
    }

    componentWillReceiveProps(newProps) {
        const evaluate = evaluateFormulas(newProps.context)
        const evaluateOld = evaluateFormulas(this.props.context)
        const newVal = evaluate(newProps.config.attributes.defaultValue)
        const oldVal = evaluateOld(this.props.config.attributes.defaultValue)
        if (oldVal !== newVal) {
            this.setState({ value: newVal })
        }
    }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle }) => (
                    <Fragment>
                        <DefineProperty
                            name={attrs.name || this.props.id}
                            description="input value"
                            type="string"
                            value={this.state.value}
                            onPersistedValue={value => this.setState({ value })}
                            tags={["form"]}
                        />

                        <Input
                            style={{ ...computedStyle, width: "100%" }}
                            value={this.state.value}
                            placeholder={attrs.placeholder}
                            onChange={event => {
                                this.setState({ value: event.target.value })
                            }}
                        />

                        <DefineAction
                            name={this.props.id + ": Capture canvas"}
                            action={this.getValue}
                        />
                    </Fragment>
                )}
            </Wrapper>
        )
    }
}

HTML2CanvasBlockType.attributes = [
    text({ field: "name", label: "Field Name" }),
    text({ field: "elementId", label: "ID of block to capture" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/HTML2CanvasBlock.js